<script lang="ts">
    import { Button } from '@tadpoles/design-kit'
    import {
        AdaptiveDialogController,
        AdaptiveDialogMobileBreakpoint
    } from '$lib/ui/overlay/adaptive-dialog-controller.svelte.js'
    import type { AccountDeletionManualRemovalKind } from '$lib/services/account-deletion.svelte.js'
    import type { AccountDeletionText } from './account-deletion-text.js'

    type AccountDeletionManualRemovalDialogProps = {
        kind: AccountDeletionManualRemovalKind
        onClose: () => void
        text: AccountDeletionText
    }

    let { kind, onClose, text }: AccountDeletionManualRemovalDialogProps = $props()
    let innerWidth = $state(0)

    const dialog = new AdaptiveDialogController({
        dismissalBlocked: () => true,
        mobile: () => innerWidth < AdaptiveDialogMobileBreakpoint,
        onClose: () => onClose(),
        returnFocusTo: () => undefined,
        swipeDismissEnabled: () => false
    })
    const message = $derived(
        kind === 'native-wrapper' ? text.manualRemovalNativeWrapper : text.manualRemovalBrowser
    )
</script>

<svelte:window bind:innerWidth onkeydown={dialog.handleKeydown} />

<div
    aria-labelledby="account-deletion-manual-removal-title"
    aria-describedby="account-deletion-manual-removal-message"
    aria-modal="true"
    {@attach dialog.attachDialog}
    class="fixed inset-0 z-[110] flex items-center justify-center bg-ts-modal-overlay p-5"
    data-testid="account-deletion-manual-removal-dialog"
    onclick={dialog.handleBackdropClick}
    onkeydown={dialog.handleKeydown}
    role="alertdialog"
    tabindex="-1"
>
    <section
        class="grid w-full max-w-[478px] gap-6 rounded-lg bg-white p-5 text-ts-text-primary shadow-[0_15px_37.5px_rgba(0,0,0,0.18)] md:p-8"
    >
        <div class="grid gap-3">
            <h2
                class="m-0 text-2xl leading-8 font-semibold"
                id="account-deletion-manual-removal-title"
            >
                {text.manualRemovalTitle}
            </h2>
            <p class="m-0 text-base leading-6" id="account-deletion-manual-removal-message">
                {message}
            </p>
        </div>
        <Button
            class="justify-self-end"
            label={text.manualRemovalClose}
            onclick={onClose}
            type="button"
            variant="primary"
        />
    </section>
</div>
